import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { HistorySidebar } from './history-sidebar';
import { RudderstackTracker } from '../../../../infra/observability/rudderstack/rudderstack';
import { REPORTING_BOT_HISTORY_CONVERSATION_CLICKED, REPORTING_BOT_HISTORY_VIEWED, } from '../../../../infra/observability/rudderstack/events';
export var HistorySidebarContainer = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onNewConversation = _a.onNewConversation, onOpenExistingChat = _a.onOpenExistingChat, history = _a.history, isLoading = _a.isLoading;
    useEffect(function () {
        if (isOpen) {
            RudderstackTracker.getInstance().track(REPORTING_BOT_HISTORY_VIEWED);
        }
    }, [isOpen]);
    var handleOpenExistingChat = function (chatId) {
        RudderstackTracker.getInstance().track(REPORTING_BOT_HISTORY_CONVERSATION_CLICKED);
        onOpenExistingChat(chatId);
    };
    return (_jsx(HistorySidebar, { history: history, isLoading: isLoading, isOpen: isOpen, onClose: onClose, onNewConversation: onNewConversation, onOpenExistingChat: handleOpenExistingChat }));
};
